import { useEffect } from 'react';
import styles from './Notification.module.scss';
import { ReactComponent as ErrorIcon } from '@/assets/Icons/rederror.svg';

import { ReactComponent as SuccessIcon } from '@/assets/Icons/succsess.svg';
import { ReactComponent as WarningIcon } from '@/assets/Icons/warning.svg';
import { useNotificationStore } from '../../store/NotificationStore';

import { Reward } from '../Reward/Reward';

import WebApp from '@twa-dev/sdk';

const Notification = () => {
  const message = useNotificationStore((state) => state.notification.message);
  const type = useNotificationStore((state) => state.notification.type);
  const rewards = useNotificationStore((state) => state.notification.rewards);
  const closeNotification = useNotificationStore(
    (state) => state.closeNotification,
  );
  WebApp;

  useEffect(() => {
    if (WebApp && WebApp.HapticFeedback && message) {
      if (type === 'Error') {
        WebApp.HapticFeedback.notificationOccurred('error');
      } else if (type === 'Warning') {
        WebApp.HapticFeedback.notificationOccurred('warning');
      } else {
        WebApp.HapticFeedback.notificationOccurred('success');
      }
    } else {
      console.warn('Telegram WebApp or HapticFeedback is not available');
    }
  }, [type]);

  // Группируем награды по типу и преобразуем в числа
  const heartsReward =
    rewards?.find((reward) => reward.type === 'hearts')?.amount || 0;

  return (
    <div className={styles.containerWrapper}>
      <div
        className={
          type === 'Error'
            ? styles.blurCircleError
            : type === 'Warning'
              ? styles.blurCircleWarning
              : styles.blurCircleSuccess
        }
      ></div>
      <div className={styles.icon}>
        {type === 'Error' ? (
          <ErrorIcon />
        ) : type === 'Warning' ? (
          <WarningIcon />
        ) : (
          <SuccessIcon />
        )}
      </div>
      <div className={styles.message}>
        <div
          className={
            type === 'Error'
              ? styles.errorText
              : type === 'Warning'
                ? styles.warningText
                : styles.successText
          }
        >
          {message}
        </div>
        {type === 'Success' && rewards && (
          <div className={styles.rewards}>
            {heartsReward > 0 && (
              <Reward type="hearts" amount={Number(heartsReward)} />
            )}
          </div>
        )}
      </div>
      <div
        onClick={() => {
          console.log('clicked');
          closeNotification();
        }}
        className={styles.closeButton}
      ></div>
    </div>
  );
};

export default Notification;
